import { useEffect, useState } from 'react';
import {
  HeroImage,
  loadHeroImages,
  DEFAULT_HERO_IMAGES,
} from '../data/hero-images';
import { getHeroImages } from '../lib/api';
import type { HeroImageDto } from '../lib/api-types';

function mapHeroDto(row: HeroImageDto): HeroImage {
  return {
    id: row.id,
    url: row.url,
    captionEn: row.alt?.en,
    captionAr: row.alt?.ar,
  };
}

/**
 * Hero slideshow images — loaded from GET /api/hero-images with bundled fallback.
 */
export function useHeroImages(): HeroImage[] {
  const [images, setImages] = useState<HeroImage[]>(DEFAULT_HERO_IMAGES);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getHeroImages();
        const mapped = res.data.map(mapHeroDto);
        if (!cancelled && mapped.length > 0) setImages(mapped);
      } catch {
        console.warn(
          '[api] hero images fetch failed, using bundled fallback',
        );
        if (!cancelled) setImages(loadHeroImages());
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return images;
}
